module.exports = __webpack_public_path__ + "static/media/al.d4541e70.svg";